import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HeaderRegister } from 'components';
import { resetItemUpdate } from '../CpapDetail/slices';
import Error from './Error';
import RegisterFirstStep from './RegisterFirstStep';
import RegisterSecondStep from './RegisterSecondStep';
import RegisterThirdStep from './RegisterThirdStep';
import RegisterStepFour from './RigisterStepFour';
import { resetState } from './slices';
import Wrap from './styles';

const Register: FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [itemId, setItemId] = useState<string>('');

  const dispatch = useDispatch();

  const stepToPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const nextStep = (itemID?: string) => {
    itemID && setItemId(itemID);
    currentStep < 4 && setCurrentStep(1 + currentStep);
  };

  const redirectToFirstStep = () => {
    setCurrentStep(0);
  };

  const onError = () => {
    setCurrentStep(4);
  };

  const screen = () => {
    switch (currentStep) {
      case 0:
        return <RegisterFirstStep nextStep={nextStep} />;
      case 1:
        return <RegisterSecondStep nextStep={nextStep} />;
      case 2:
        return <RegisterThirdStep error={onError} stepToPrevious={stepToPrevious} nextStep={nextStep} />;
      case 3:
        return <RegisterStepFour itemId={itemId} redirectToFirstStep={redirectToFirstStep} />;
      case 4:
        return <Error />;
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetItemUpdate);
  });

  return (
    <Wrap>
      {currentStep === 4 ? (
        ''
      ) : (
        <HeaderRegister nextStep={nextStep} currentStep={currentStep} backStepPrevious={stepToPrevious} />
      )}
      {screen()}
    </Wrap>
  );
};

export default Register;
